<h1 mat-dialog-title>
  {{ (form?.controls)['full_name']?.value }}
  <mat-icon style="float: left; cursor: pointer;" (click)="closeDialog()">close</mat-icon>
</h1>
<div mat-dialog-content class="mrg-btm-15">
  <form fxFlex fxLayout="column" class="core-form-style" [formGroup]="form">
    <div fxFlex="">
      <div fxFlex="">
        <app-core-form-content
          [cid]="service.cid"
          [service]="service"
          [field]="service.getFieldByName('avatar')"
          [form]="form"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        >
        </app-core-form-content>
      </div>
      <div fxFlex="">
        <app-core-form-content
          [cid]="service.cid"
          [service]="service"
          [field]="service.getFieldByName('full_name')"
          [form]="form"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        >
        </app-core-form-content>
        <app-core-form-content
          [cid]="service.cid"
          [service]="service"
          [field]="service.getFieldByName('email')"
          [form]="form"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        >
        </app-core-form-content>
        <app-core-form-content
          [cid]="service.cid"
          [service]="service"
          [field]="service.getFieldByName('phone')"
          [form]="form"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        >
        </app-core-form-content>
        <app-core-form-content
          class="mrg-btm-15"
          [cid]="service.cid"
          [service]="service"
          [field]="service.getFieldByName('changePassword')"
          [form]="form"
          [isEdit]="isEdit"
          [isClone]="isClone"
          [isSubmitted]="isSubmitted"
        >
        </app-core-form-content>
        <ng-container *ngIf="fieldShowConditions(service.getFieldByName('old_password'))">
          <app-core-form-content
            [cid]="service.cid"
            [service]="service"
            [field]="service.getFieldByName('old_password')"
            [form]="form"
            [isEdit]="isEdit"
            [isClone]="isClone"
            [isSubmitted]="isSubmitted"
          >
          </app-core-form-content>
        </ng-container>
        <ng-container *ngIf="fieldShowConditions(service.getFieldByName('password'))">
          <app-core-form-content
            [cid]="service.cid"
            [service]="service"
            [field]="service.getFieldByName('password')"
            [form]="form"
            [isEdit]="isEdit"
            [isClone]="isClone"
            [isSubmitted]="isSubmitted"
          >
          </app-core-form-content>
        </ng-container>

        <ng-container *ngIf="fieldShowConditions(service.getFieldByName('password_confirmation'))">
          <app-core-form-content
            [cid]="service.cid"
            [service]="service"
            [field]="service.getFieldByName('password_confirmation')"
            [form]="form"
            [isEdit]="isEdit"
            [isClone]="isClone"
            [isSubmitted]="isSubmitted"
          >
          </app-core-form-content>
        </ng-container>
      </div>
    </div>
  </form>
</div>

<div mat-dialog-content class="mat-dialog-actions">
  <app-form-footer
    (submit)="formSubmission()"
    (saveAddNew)="formSubmission(true)"
    (cancel)="cancelFormSubmission()"
    [form]="form"
    [isSaveAddNew]="isSaveAddNew"
    [isEdit]="isEdit"
    [isClone]="isClone"
    [isSubmitted]="isSubmitted"
    [formValid]="formValid"
  ></app-form-footer>
</div>
